import { createContext as e, useContext as t } from "react";
import { noop as n } from "es-toolkit/function";
var r = e({
	onClose: n,
	isSmallestDialog: !1,
	showXsDialogBorders: !1,
	showCloseButton: !0
}), i = r.Provider, a = () => {
	let e = t(r);
	if (!e) throw Error("Dialog compound components cannot be rendered outside the Dialog component");
	return e;
};
//#endregion
export { i as DialogContextProvider, r as dialogContext, a as useDialogContext };

//# sourceMappingURL=dialogContext.js.map